// eslint-disable-next-line import/prefer-default-export
export const getCadastroAdicional = (cadastrosAdicionais, tipo) => (cadastrosAdicionais
  ? cadastrosAdicionais.find(cadastro => cadastro.tipo === tipo)
  : null);
